exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".layout-extra-sidebar{width:200px;-webkit-box-flex:0;-ms-flex:none;flex:none;background:#fffefe;border-right:1px solid #b6b6b6;-webkit-box-shadow:0 2px 4px 0 rgba(0,5,8,.07);box-shadow:0 2px 4px 0 rgba(0,5,8,.07)}.layout-extra-sidebar>ul li.active a{color:#0884f3;background:#ecf4fd}.layout-extra-sidebar>ul li:hover a{background:#f0f0f0}.layout-extra-sidebar>ul li a{height:40px;line-height:40px;padding:0 20px;display:block}", ""]);

// exports
